import { atom } from 'recoil';

export const complianceSelectedBranch = atom({ key: 'complianceSelectedBranch', default: null });

export const complianceSelectedPosition = atom({ key: 'complianceSelectedPosition', default: null });

export const complianceSelectedActiveStatus = atom({ key: 'complianceSelectedActiveStatus', default: 1 });
